import age from 'ager';
import { passwordStrength } from './password-strength';
export var ValidationError;
(function (ValidationError) {
    ValidationError["FIELD_EMPTY"] = "field_empty";
    ValidationError["FIELD_SHORT"] = "field_short";
    ValidationError["FIELD_LONG"] = "field_long";
    ValidationError["FIELD_INVALID"] = "field_invalid";
    ValidationError["EMAIL_EMPTY"] = "email_empty";
    ValidationError["EMAIL_INVALID"] = "email_invalid";
    ValidationError["EMAIL_LOGIN_OFF_SIZE"] = "email_login_off_size";
    ValidationError["EMAIL_LOGIN_INVALID"] = "email_login_invalid";
    ValidationError["EMAIL_LOGIN_EMPTY"] = "email_login_empty";
    ValidationError["PASSWORD_EMPTY"] = "password_empty";
    ValidationError["PASSWORD_INVALID"] = "password_invalid";
    ValidationError["PASSWORD_CYRILLIC_CHARS"] = "password_cyrillic_chars";
    ValidationError["PASSWORD_NOT_SUPPORTED_CHARS"] = "password_not_supported_chars";
    ValidationError["PASSWORD_MATCH"] = "password_match";
    ValidationError["PASSWORD_CONFIRM"] = "password_confirm";
    ValidationError["BIRTHDAY_EMPTY"] = "birthday_empty";
    ValidationError["BIRTHDAY_INVALID"] = "birthday_invalid";
    ValidationError["BIRTHDAY_MIN"] = "birthday_min";
    ValidationError["GENDER_EMPTY"] = "gender_empty";
    ValidationError["GEO_EMPTY"] = "geo_empty";
    ValidationError["RECAPTCHA_EMPTY"] = "recaptcha_empty";
    ValidationError["CAPTCHA_EMPTY"] = "captcha_empty";
    ValidationError["AGREEMENT_EMPTY"] = "agreement_empty";
    ValidationError["QUESTION_EMPTY"] = "question_empty";
    ValidationError["QUESTION_LONG"] = "question_long";
    ValidationError["ANSWER_EMPTY"] = "answer_empty";
    ValidationError["ANSWER_LONG"] = "answer_long";
    ValidationError["PHONE_EMPTY"] = "phone_empty";
    ValidationError["PHONE_INVALID"] = "phone_invalid";
    ValidationError["SMS_CODE_EMPTY"] = "sms_code_empty";
})(ValidationError || (ValidationError = {}));
export const fieldEmpty = (value = '') => {
    if (value.trim().length === 0) {
        return ValidationError.FIELD_EMPTY;
    }
};
export const fieldInvalid = (value = '', min = 1, max = 32, regex = /^[a-zа-яё0-9_ -]*$/i) => {
    if (value.trim().length === 0) {
        return;
    }
    if (value.length < min) {
        return [ValidationError.FIELD_SHORT, min];
    }
    if (value.length > max) {
        return [ValidationError.FIELD_LONG, max];
    }
    if (!regex.test(value)) {
        return ValidationError.FIELD_INVALID;
    }
};
export const emailEmpty = (value = '') => {
    if (!value) {
        return ValidationError.EMAIL_EMPTY;
    }
};
export const emailInvalid = (value = '') => {
    const emailRegex = /^[+a-zA-Z0-9_.!#$%&'*/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;
    if (value && !emailRegex.test(value)) {
        return ValidationError.EMAIL_INVALID;
    }
};
export const emailLogin = (value = '') => {
    const [username = ''] = value ? value.split(/@([^@]+\.[^@]+)$/) : [];
    if (!username) {
        return ValidationError.EMAIL_LOGIN_EMPTY;
    }
    if (username.length < 3 || username.length > 32) {
        return ValidationError.EMAIL_LOGIN_OFF_SIZE;
    }
    const usernameRegex = /^[a-z0-9][a-z0-9_.-]*[a-z0-9]$/i;
    const invalidChar = /[_.-]{2,}/;
    if (!usernameRegex.test(username) || invalidChar.test(username)) {
        return ValidationError.EMAIL_LOGIN_INVALID;
    }
};
export const passwordEmpty = (value = '') => {
    if (!value) {
        return ValidationError.PASSWORD_EMPTY;
    }
};
export const passwordInvalid = (value = '') => {
    if (passwordStrength(value) < 3 || value.length > 32) {
        return ValidationError.PASSWORD_INVALID;
    }
};
export const passwordChars = (value = '') => {
    if (/[а-яё]/i.test(value)) {
        return ValidationError.PASSWORD_CYRILLIC_CHARS;
    }
    const invalidChar = value.match(/[^\w!@$%^&*()\-+]/);
    if (invalidChar) {
        return [ValidationError.PASSWORD_NOT_SUPPORTED_CHARS, invalidChar];
    }
};
export const passwordMatch = (password, confirmation) => {
    if (password && password === confirmation) {
        return ValidationError.PASSWORD_MATCH;
    }
};
export const passwordConfirm = (password, confirmation) => {
    if (password && password !== confirmation) {
        return ValidationError.PASSWORD_CONFIRM;
    }
};
export const dateEmpty = ([day = 0, month = 0, year = 0] = []) => {
    if (!day || !month || !year) {
        return ValidationError.BIRTHDAY_EMPTY;
    }
};
export const dateInvalid = ([day = 0, month = 0, year = 0] = [], min = -Infinity) => {
    if ((day | month | year) === 0) {
        return;
    }
    const stamp = new Date(Date.UTC(year, month - 1, day));
    if (stamp.getUTCFullYear() !== +year ||
        stamp.getUTCMonth() !== +month - 1 ||
        stamp.getUTCDate() !== +day) {
        return ValidationError.BIRTHDAY_INVALID;
    }
    try {
        if (age(year, month, day) >= min) {
            return;
        }
    }
    catch (error) {
        if (min === -Infinity) {
            return ValidationError.BIRTHDAY_INVALID;
        }
    }
    return [ValidationError.BIRTHDAY_MIN, min];
};
export const genderEmpty = (value = '') => {
    if (value !== 'm' && value !== 'f') {
        return ValidationError.GENDER_EMPTY;
    }
};
export const geoEmpty = (value = '') => {
    if (!value || value === 0) {
        return ValidationError.GEO_EMPTY;
    }
};
export const reCaptchaEmpty = (value) => {
    if (typeof value === 'undefined') {
        return;
    }
    const [, orderValue] = value.split(/@/);
    if (!orderValue) {
        return ValidationError.RECAPTCHA_EMPTY;
    }
};
export const captchaEmpty = (value) => {
    if (typeof value === 'undefined') {
        return;
    }
    const [, orderValue] = value.split(/@/);
    if (!orderValue) {
        return ValidationError.CAPTCHA_EMPTY;
    }
};
export const agreementEmpty = (value = false) => {
    if (!value) {
        return ValidationError.AGREEMENT_EMPTY;
    }
};
export const questionInvalid = (value = '') => {
    if (value.length === 0) {
        return ValidationError.QUESTION_EMPTY;
    }
    if (value.length > 100) {
        return ValidationError.QUESTION_LONG;
    }
};
export const answerInvalid = (value = '') => {
    if (value.length === 0) {
        return ValidationError.ANSWER_EMPTY;
    }
    if (value.length > 64) {
        return ValidationError.ANSWER_LONG;
    }
};
export const phoneEmpty = (value = '') => {
    const [, number = ''] = value ? value.split(/\s/) : [];
    if (!number.length) {
        return ValidationError.PHONE_EMPTY;
    }
};
export const phoneInvalid = (value = '') => {
    const format = /^\+?([87](?!95[5-7]|998|907|94[^09]|336)([348]\d|9[0-6789]|7[01247])\d{8}|[1246]\d{9,13}|68\d{7}|5[1-46-9]\d{8,12}|55[1-9]\d{9}|55[138]\d{10}|55[1256][14679]9\d{8}|554399\d{7}|500[56]\d{4}|5016\d{6}|5068\d{7}|502[345]\d{7}|5037\d{7}|50[4567]\d{8}|50855\d{4}|509[34]\d{7}|376\d{6}|855\d{8,9}|856\d{10}|85[0-4789]\d{8,10}|8[68]\d{10,11}|8[14]\d{10}|82\d{9,10}|852\d{8}|90\d{10}|96(0[79]|17[0189]|181|13)\d{6}|96[23]\d{9}|964\d{10}|96(5[569]|89)\d{7}|96(65|77)\d{8}|92[023]\d{9}|91[1879]\d{9}|9[34]7\d{8}|959\d{7,9}|989\d{9}|971\d{8,9}|97[02-9]\d{7,11}|99[^4568]\d{7,11}|994\d{9}|995[57]\d{8}|996[2579]\d{8}|998[235789]\d{8}|380[345679]\d{8}|381\d{9}|38[57]\d{8,9}|375[234]\d{8}|372\d{7,8}|37[0-4]\d{8}|37[6-9]\d{7,11}|30[69]\d{9}|34[679]\d{8}|3459\d{11}|316\d{8}|324\d{8}|33[67]\d{8}|35\d{8,12}|36\d{9}|39\d{8,10}|38[169]\d{8}|382\d{8,9}|46719\d{10})$/; // eslint-disable-line max-len
    const [code, number = ''] = value ? value.split(/\s/) : [];
    if (number.length && !format.test(`${code}${number}`)) {
        return ValidationError.PHONE_INVALID;
    }
};
export const phoneUnavailableForCalls = (value = '') => {
    // Beeline and Tinkoff do not process OTPs via calls anymore
    const format = /^(995|900|902|903|904|905|906|908|909|950|951|953|960|961|962|963|964|965|966|967|968|969|980|983|986)/;
    const [, number = ''] = value ? value.split(/\s/) : [];
    if (number.length && format.test(number)) {
        return ValidationError.PHONE_INVALID;
    }
};
export const smsCodeEmpty = (value = '', min = 6) => {
    if (!value || value.length < min) {
        return ValidationError.SMS_CODE_EMPTY;
    }
};
